import React from 'react';
import Props from './props';
import PrimaryButton from './primary-button';

export default class SubmitButton extends React.Component<Props, any> {
  render() {
    return <PrimaryButton {...this.props} type="submit" />;
  }
}
